import { Personal } from '@/components/Personal';

export default {
  path: '/personal/',
  component: Personal,
  meta: {
    text: 'ユーザー設定',
  },
};
